import Vue from 'vue';
import VueRouter from 'vue-router';
// import Layout from 'components/Layout.vue'
import Layout from '@/layout';
import RouterView from '@/components/RouterView'
// import NotFound from '@/views/404.vue';

Vue.use(VueRouter);

export const constantRoutes = [
    {
        path: '/',
        component: Layout,
        redirect: '/home',
        // children: [
        //     {
        //         path: 'home',
        //         component: () => import('../views/Home.vue'),
        //         name: 'home',
        //         meta: {title: '首页', icon: 'icon-jt-home', affix: true},
        //     },
        // ]
    },
    // {
    //     path: '/',
    //     component: Layout,
    //     redirect: '/home2',
    //     children: [
    //         {
    //             path: 'home2',
    //             component: () => import('../views/Home2.vue'),
    //             name: 'home2',
    //             meta: {title: '首页-面板', icon: 'icon-jt-home', affix: true},
    //         },
    //     ]
    // },
    // {
    //     path: '/login',
    //     name: 'login',
    //     component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    //     hidden: true,
    //     meta: {
    //         title: '登录'
    //     }
    // },
    {
        path: '/bind',
        name: 'bind',
        component: () => import(/* webpackChunkName: "login" */ '../views/Bind.vue'),
        hidden: true,
        meta: {
            title: '微信绑定',
        }
    },
    {
        path: '/regist',
        name: 'regist',
        component: () => import(/* webpackChunkName: "regist" */ '../views/Regist.vue'),
        hidden: true,
        meta: {
            title: '注册'
        }
    },
    // contact
    {
        path: '/contact',
        name: 'contact',
        component: () => import(/* webpackChunkName: "regist" */ '../views/Contact.vue'),
        hidden: true,
        meta: {
            title: '禁止访问'
        }
    },
    {
        path: '/auc',
        name: 'auc',
        component: () => import(/* webpackChunkName: "auc" */ '../views/AUC.vue'),
        hidden: true,
        meta: {
            title: '登录中',
        }
    },
    {
        path: '/test',
        name: 'test',
        component: () => import('../views/test/Test3.vue'),   //../views/test/Test1.vue
        hidden: true,
        meta: {
            title: '测试页面',
        }
    },
];

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   菜单栏是否显示
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           面包屑导航是否能点击
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    基于role的权限控制
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

export const asyncRoutes = [
    {
        path: '/home',
        name: 'home',
        component: Layout,
        // component: () => import('../views/Home.vue'),
        alwaysShow:true,
        meta: {
            title: "首页",
            icon: 'icon-jt-home',
        },
        children: [
            {
                path: '/home/media_director',
                name: 'media_director',
                component:  () => import('@/views/dashboard/media.vue'),
                meta: {
                    title: "媒介负责人",
                    isTabPage:false,
                    activeMenu:'/home/media_director',
                },
            },
            {
                path: '/home/yy_director',
                name: 'yy_director',
                component:  () => import('@/views/dashboard/yunying.vue'),
                meta: {
                    title: "运营负责人",
                    isTabPage:false,
                    activeMenu:'/home/yy_director',
                },
            },
            {
                path: '/home/xs_director',
                name: 'xs_director',
                component:  () => import('@/views/dashboard/sale.vue'),
                meta: {
                    title: "销售负责人",
                    isTabPage:false,
                    activeMenu:'/home/xs_director',
                },
            },
            {
                path: '/home/kf_director',
                name: 'kf_director',
                component:  () => import('@/views/dashboard/kefu.vue'),
                meta: {
                    title: "客服负责人",
                    isTabPage:false,
                    activeMenu:'/home/kf_director',
                },
            }
        ],
    },
    {
        path: '/data_center',
        name: 'data_center',
        component: Layout,
        alwaysShow:false,
        meta: {
            title: "数据中心",
            icon: 'icon-jt-datas',
            desc:'数据中心页面',
        },
        children: [
            {
                path: '/data_center/data_query_analysis',
                name: 'data_query_analysis',
                component:  () => import('@/views/dataCenter/QueryAnalysis.vue'),
                meta: {
                    title: "综合查询分析",
                    isTabPage:true,
                    activeMenu:'/data_center/data_query_analysis',
                },
                alwaysShow:false,
                children:[
                    {
                        path:'/data_center/data_query_analysis/data_all',
                        name:'data_all',
                        component: () => import('@/views/dataCenter/QueryAnalysis.vue'),
                        meta: {
                            title: "整体分析",
                            activeMenu:'/data_center/data_query_analysis',
                        },
                    },
                    {
                        path:'/data_center/data_query_analysis/data_1',
                        name:'data_1',
                        component: () => import('@/views/dataCenter/QueryAnalysis.vue'),
                        meta: {
                            title: "OPPO分析",
                            activeMenu:'/data_center/data_query_analysis',
                        },
                    },
                    {
                        path:'/data_center/data_query_analysis/data_3',
                        name:'data_3',
                        component: () => import('@/views/dataCenter/QueryAnalysis.vue'),
                        meta: {
                            title: "vivo分析",
                            activeMenu:'/data_center/data_query_analysis',
                        },
                    },
                    {
                        path:'/data_center/data_query_analysis/data_4',
                        name:'data_4',
                        component: () => import('@/views/dataCenter/QueryAnalysis.vue'),
                        meta: {
                            title: "华为分析",
                            activeMenu:'/data_center/data_query_analysis',
                        },
                    },
                    {
                        path:'/data_center/data_query_analysis/data_10',
                        name:'data_10',
                        component: () => import('@/views/dataCenter/QueryAnalysis.vue'),
                        meta: {
                            title: "华为Ads分析",
                            activeMenu:'/data_center/data_query_analysis',
                        },
                    },
                    {
                        path:'/data_center/data_query_analysis/data_11',
                        name:'data_11',
                        component: () => import('@/views/dataCenter/QueryAnalysis.vue'),
                        meta: {
                            title: "荣耀分析",
                            activeMenu:'/data_center/data_query_analysis',
                        },
                    },
                    {
                        path:'/data_center/data_query_analysis/data_7',
                        name:'data_7',
                        component: () => import('@/views/dataCenter/QueryAnalysis.vue'),
                        meta: {
                            title: "小米分析",
                            activeMenu:'/data_center/data_query_analysis',
                        },
                    },
                    {
                        path:'/data_center/data_query_analysis/data_37',
                        name:'data_37',
                        component: () => import('@/views/dataCenter/QueryAnalysis.vue'),
                        meta: {
                            title: "小米4.0分析",
                            activeMenu:'/data_center/data_query_analysis',
                        },
                    },
                    {
                        path:'/data_center/data_query_analysis/data_12',
                        name:'data_12',
                        component: () => import('@/views/dataCenter/QueryAnalysis.vue'),
                        meta: {
                            title: "小米海外",
                            activeMenu:'/data_center/data_query_analysis',
                        },
                    },
                    {
                        path:'/data_center/data_query_analysis/data_8',
                        name:'data_8',
                        component: () => import('@/views/dataCenter/QueryAnalysis.vue'),
                        meta: {
                            title: "爱奇艺分析",
                            activeMenu:'/data_center/data_query_analysis',
                        },
                    },
                    {
                        path:'/data_center/data_query_analysis/data_9',
                        name:'data_9',
                        component: () => import('@/views/dataCenter/QueryAnalysis.vue'),
                        meta: {
                            title: "Apple分析",
                            activeMenu:'/data_center/data_query_analysis',
                        },
                    },
                ]
            },
            {
                path: '/data_center/material_query_analysis',
                name: 'material_query_analysis',
                component:  () => import('@/views/dataCenter/material'),
                meta: {
                    title: "素材查询分析",
                    isTabPage:false,
                },
            },
            {
                path: '/data_center/compete_plat_username_manage',
                name: 'compete_plat_username_manage',
                component:  () => import('@/views/dataCenter/competeManage/index.vue'),
                meta: {
                    title: "竞代数据管理",
                    isTabPage:false,
                },
            },
            {
                path: '/data_center/app_kpi_manage',
                name: 'app_kpi_manage',
                component:  () => import('@/views/dataCenter/appKpiManage/index.vue'),
                meta: {
                    title: "产品KPI管理",
                    isTabPage:true,
                    desc:"产品KPI管理页面",
                    activeMenu:'/data_center/app_kpi_manage',
                },
                alwaysShow:false,
                children:[
                    {
                        path:'/data_center/app_kpi_manage/app_kpi_1',
                        name:'app_kpi_1',
                        component: () => import('@/views/dataCenter/appKpiManage/page/listPage.vue'),
                        meta: {
                            title: "OPPO",
                            activeMenu:'/data_center/app_kpi_manage',
                            desc:"OPPO渠道产品KPI管理页面",
                        },
                    },
                    {
                        path:'/data_center/app_kpi_manage/app_kpi_3',
                        name:'app_kpi_3',
                        component: () => import('@/views/dataCenter/appKpiManage/page/listPage.vue'),
                        meta: {
                            title: "vivo",
                            activeMenu:'/data_center/app_kpi_manage',
                            desc:"vivo渠道产品KPI管理页面",
                        },
                    },
                    {
                        path:'/data_center/app_kpi_manage/app_kpi_7',
                        name:'app_kpi_7',
                        component: () => import('@/views/dataCenter/appKpiManage/page/listPage.vue'),
                        meta: {
                            title: "小米",
                            activeMenu:'/data_center/app_kpi_manage',
                            desc:"小米渠道产品KPI管理页面",
                        },
                    },
                ]
            }
        ],
    },
    {
        path: '/intelligent',
        name:'intelligent',
        component: Layout,
        alwaysShow:false,
        meta: {
            title: "智能投放",
            icon: 'icon-jt-a-zhineng4',
            desc:'智能投放',
        },
        children:[
            {
                path: '/intelligent/intelligent_managed',
                name: 'intelligent_managed',
                component:  () => import('@/views/intelligent/intelligentManaged/index.vue'),
                meta: {
                    title: "智能托管",
                    isTabPage:true,
                    activeMenu:'/intelligent/intelligent_managed',
                    desc:'此页面展示智能托管相关功能',
                },
                alwaysShow:false,
                children:[
                    {
                        path:'/intelligent/intelligent_managed/intelligent_managed_rule',
                        name:'intelligent_managed_rule',
                        meta: {
                            title: "托管规则",
                            activeMenu:'/intelligent/intelligent_managed',
                            desc:'托管规则',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/intelligent/intelligent_managed/intelligent_managed_run_record',
                        name:'intelligent_managed_run_record',
                        meta: {
                            title: "运行记录",
                            activeMenu:'/intelligent/intelligent_managed',
                            desc:'运行记录',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/marketing_management/apple/intelligent_managed_trigger_record',
                        name:'intelligent_managed_trigger_record',
                        meta: {
                            title: "触发记录",
                            activeMenu:'/intelligent/intelligent_managed',
                            desc:'触发记录',
                            isTabItem:true,
                        },
                    },
                ],
            },
        ],
    },
    {
        path: '/marketing_management',
        name:'marketing_management',
        component: Layout,
        alwaysShow:false,
        meta: {
            title: "推广管理",
            icon: 'icon-jt-ad',
            desc:'此页面展示所有媒体相关数据内容与广告管理。',
        },
        children:[
            {
                path: '/marketing_management/oppo',
                name: 'oppo',
                component:  () => import('@/views/marketingManagement/oppo/index.vue'),
                meta: {
                    title: "OPPO",
                    isTabPage:true,
                    activeMenu:'/marketing_managementindex/oppo',
                    desc:'此页面展示OPPO媒体相关数据内容与广告管理',
                },
                alwaysShow:false,
                children:[
                    {
                        path:'/marketing_management/oppo/oppo_batch_create',
                        name:'oppo_batch_create',
                        component: () => import('@/views/marketingManagement/oppo/batchCreate.vue'),
                        meta: {
                            title: "批量创建",
                            activeMenu:'/marketing_management/oppo',
                            desc:'广告批量搭建',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/marketing_management/oppo/oppo_plan_copy/:type',
                        name:'oppo_plan_copy',
                        component: () => import('@/views/marketingManagement/oppo/copyPlan.vue'),
                        meta: {
                            title: "计划复制",
                            activeMenu:'/marketing_management/oppo',
                            desc:'广告批量搭建',
                            isTabItem:true,
                            params:{type:'list'},
                        },
                    },
                ]
            },
            {
                path: '/marketing_management/vivo',
                name: 'vivo',
                component:  () => import('@/views/marketingManagement/vivo/batchCreate.vue'),
                meta: {
                    title: "vivo",
                    isTabPage:true,
                    activeMenu:'/marketing_management/vivo',
                    desc:'此页面展示vivo媒体相关数据内容与广告管理',
                },
                alwaysShow:false,
                children:[
                    {
                        path:'/marketing_management/vivo/vivo_batch_create',
                        name:'vivo_batch_create',
                        component: () => import('@/views/marketingManagement/vivo/batchCreate.vue'),
                        meta: {
                            title: "批量创建",
                            activeMenu:'/marketing_management/vivo',
                            desc:'广告批量搭建',
                        },
                    },
                ]
            },
            {
                path: '/marketing_management/apple',
                name: 'apple',
                component:  () => import('@/views/marketingManagement/apple/index.vue'),
                meta: {
                    title: "Apple",
                    isTabPage:true,
                    activeMenu:'/marketing_management/apple',
                    desc:'此页面展示Apple媒体相关数据内容与广告管理',
                },
                alwaysShow:false,
                children:[
                    {
                        path:'/marketing_management/apple/apple_org',
                        name:'apple_org',
                        // component:() => import('@/views/marketingManagement/apple/org/index.vue'),
                        meta: {
                            title: "广告系列组",
                            activeMenu:'/marketing_management/apple',
                            desc:'广告系列组',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/marketing_management/apple/apple_campaign',
                        name:'apple_campaign',
                        // component:() => import('@/views/marketingManagement/apple/campaign/index.vue'),
                        meta: {
                            title: "广告系列",
                            activeMenu:'/marketing_management/apple',
                            desc:'广告系列',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/marketing_management/apple/apple_adgroup',
                        name:'apple_adgroup',
                        // component:() => import('@/views/marketingManagement/apple/adGroup/index.vue'),
                        meta: {
                            title: "广告组",
                            activeMenu:'/marketing_management/apple',
                            desc:'广告组',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/marketing_management/apple/apple_keyword',
                        name:'apple_keyword',
                        // component:() => import('@/views/marketingManagement/apple/keywords/index.vue'),
                        meta: {
                            title: "关键词",
                            activeMenu:'/marketing_management/apple',
                            desc:'关键词',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/marketing_management/apple/apple_search_term',
                        name:'apple_search_term',
                        // component:() => import('@/views/marketingManagement/apple/keywords/index.vue'),
                        meta: {
                            title: "搜索词",
                            activeMenu:'/marketing_management/apple',
                            desc:'搜索词',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/marketing_management/apple/apple_negative_keyword',
                        name:'apple_negative_keyword',
                        // component:() => import('@/views/marketingManagement/apple/keywords/index.vue'),
                        meta: {
                            title: "否定关键词",
                            activeMenu:'/marketing_management/apple',
                            desc:'否定关键词',
                            isTabItem:true,
                        },
                    },
                ]
            },
            {
                path: '/marketing_management/apple_zh',
                name: 'apple_zh',
                component:  () => import('@/views/marketingManagement/appleZh/index.vue'),
                meta: {
                    title: "Apple中文",
                    isTabPage:true,
                    activeMenu:'/marketing_management/apple_zh',
                    desc:'此页面展示Apple媒体相关数据内容与广告管理',
                },
                alwaysShow:false,
            },
            {
                path: '/marketing_management/apple_en',
                name: 'apple_en',
                component:  () => import('@/views/marketingManagement/appleEn/index.vue'),
                meta: {
                    title: "AppleEnglish",
                    isTabPage:true,
                    activeMenu:'/marketing_management/apple_en',
                    desc:'此页面展示Apple媒体相关数据内容与广告管理',
                },
                alwaysShow:false,
            },
            {
                path: '/marketing_management/mi',
                name: 'mi',
                component:  RouterView,
                meta: {
                    title: "小米",
                    isTabPage:true,
                    activeMenu:'/marketing_management/mi',
                    desc:'此页面展示小米媒体相关数据内容与广告管理',
                    isRouterView: true
                },
                alwaysShow:false,
                children:[
                    {
                        path:'/marketing_management/mi/mi_batch_create',
                        name:'mi_batch_create',
                        component: () => import('@/views/marketingManagement/mi/batchCreate.vue'),
                        meta: {
                            title: "批量创建",
                            activeMenu:'/marketing_management/mi',
                            desc:'广告批量搭建',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/marketing_management/mi_v2/mi_batch_v2_create',
                        name:'mi_batch_v2_create',
                        component: () => import('@/views/marketingManagement/miAuto/batchCreate.vue'),
                        meta: {
                            title: "批量搭建-自动优化",
                            activeMenu:'/marketing_management/mi',
                            desc:'广告批量搭建-自动优化',
                            isTabItem:true,
                        },
                    },
                ]
            },
            {
                path: '/marketing_management/huawei_ads',
                name: 'huawei_ads',
                component: () => import('@/views/marketingManagement/huaweiAds/index.vue'),
                meta: {
                    title: "华为Ads",
                    isTabPage:true,
                    activeMenu:'/marketing_management/huawei_ads',
                    desc:'此页面展示华为媒体相关数据内容与广告管理',
                }
            },
            {
                path: '/marketing_management/honor',
                name: 'honor',
                component: () => import('@/views/marketingManagement/honor/index.vue'),
                meta: {
                    title: "荣耀",
                    isTabPage:true,
                    activeMenu:'/marketing_management/honor',
                    desc:'此页面展示荣耀媒体相关数据内容与广告管理',
                }
            },
        ]
    },
    {
        path: '/efficiency_tool',
        name:'efficiency_tool',
        component: Layout,
        alwaysShow:false,
        meta: {
            title: "效率工具",
            icon: 'icon-jt-tools',
            desc:'效率工具',
        },
        children:[
            {
                path: '/efficiency_tool/daily_task',
                name: 'daily_task',
                component: () => import('@/views/efficiencyTool/dailyTask/index.vue'),
                meta: {
                    title: "自动化报告",
                    isTabPage: true,
                    activeMenu: '/efficiency_tool/daily_task',
                },
                alwaysShow: false,
            },
            {
                path: '/efficiency_tool/daily_task_zh',
                name: 'daily_task_zh',
                component: () => import('@/views/efficiencyTool/dailyTaskZh/index.vue'),
                meta: {
                    title: "自动化报告中文",
                    isTabPage: true,
                    activeMenu: '/efficiency_tool/daily_task',
                },
                alwaysShow: false,
            },
            {
                path: '/efficiency_tool/daily_task_en',
                name: 'daily_task_en',
                component: () => import('@/views/efficiencyTool/dailyTaskEn/index.vue'),
                meta: {
                    title: "自动化报告English",
                    isTabPage: true,
                    activeMenu: '/efficiency_tool/daily_task_en',
                },
                alwaysShow: false,
            },
            {
                path: '/efficiency_tool/assist_tools',
                name: 'assist_tools',
                component:  () => import('@/views/efficiencyTool/assistTools/index.vue'),
                meta: {
                    title: "自助工具",
                    isTabPage:true,
                    activeMenu:'/efficiency_tool/assist_tools',
                },
                alwaysShow:false,
                children:[
                    {
                        path:'/efficiency_tool/assist_tools/assist_tools_overview',
                        name:'assist_tools_overview',
                        // component: () => import('@/views/efficiencyTool/assistTools/page/materialExportPage.vue'),
                        meta: {
                            title: "概览页面",
                            activeMenu:'/efficiency_tool/assist_tools',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/efficiency_tool/assist_tools/material_export_by_id',
                        name:'material_export_by_id',
                        // component: () => import('@/views/efficiencyTool/assistTools/page/materialExportPage.vue'),
                        meta: {
                            title: "素材内容导出",
                            activeMenu:'/efficiency_tool/assist_tools',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/efficiency_tool/assist_tools/infrastructure_export_by_id',
                        name:'infrastructure_export_by_id',
                        // component: () => import('@/views/efficiencyTool/assistTools/page/baseExportPage.vue'),
                        meta: {
                            title: "基建数据导出",
                            activeMenu:'/efficiency_tool/assist_tools',
                            isTabItem:true,
                        },
                    },
                ],
            },
            {
                path: '/efficiency_tool/ad_batch_adjustment',
                name: 'ad_batch_adjustment',
                component: () => import('@/views/efficiencyTool/ads/index.vue'),
                meta: {
                    title: "广告批量调控",
                    isTabPage: true,
                },
                alwaysShow: false,
            },
        ],
    },
    {
        path: '/work_order',
        name:'work_order',
        component: Layout,
        alwaysShow:false,
        meta: {
            title: "工单管理",
            icon: 'icon-jt-workorder',
            desc:'工单管理',
        },
        children: [
            {
                path: '/work_order/work_order_dashboard',
                name: 'work_order_dashboard',
                component: () => import('@/views/workOrder/dashboard/index.vue'),
                meta: {
                    title: "工单看板",
                    isTabPage: true,
                    activeMenu: '/work_order/work_order_dashboard',
                },
                alwaysShow: false,
            },
            {
                path: '/work_order/work_order_material',
                name: 'work_order_material',
                component: () => import('@/views/workOrder/material/index.vue'),
                meta: {
                    title: "素材工单",
                    isTabPage: true,
                    activeMenu: '/work_order/work_order_material',
                },
                alwaysShow: false,
            },
            {
                path: '/work_order/store',
                name: 'material',
                component: () => import('@/views/workOrder/store/index.vue'),
                meta: {
                    title: "素材库",
                    isTabPage: true,
                    activeMenu: '/work_order/store',
                },
                alwaysShow: false,
            },
            {
                path: '/work_order/material_conf',
                name: 'material_conf',
                component: () => import('@/views/workOrder/conf/index.vue'),
                meta: {
                    title: "素材工单配置",
                    isTabPage: true,
                    activeMenu: '/work_order/material_conf',
                },
                alwaysShow: false,
            },
        ],
    },

    {
        path: '/basic_info_management',
        name:'basic_info_management',
        component: Layout,
        alwaysShow:false,
        meta: {
            title: "信息管理",
            icon: 'icon-jt-xinxiweihu',
            desc:'此页面展示基础信息内容与管理。',
        },
        children:[
            {
                path: '/basic_info_management/tag_management',
                name: 'tag_management',
                component:  () => import('@/views/basicInfoManagement/tagManagement/index.vue'),
                meta: {
                    title: "标签管理",
                    isTabPage:true,
                    activeMenu:'/basic_info_management/tag_management',
                },
                alwaysShow:false,
                children:[
                    {
                        path:'/basic_info_management/tag_management/tag_management_page',
                        name:'tag_management_page',
                        component: () => import('@/views/basicInfoManagement/tagManagement/index.vue'),
                        meta: {
                            title: "标签维护页面",
                            activeMenu:'/basic_info_management/tag_management',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/basic_info_management/tag_management/plat_management_page',
                        name:'plat_management_page',
                        component: () => import('@/views/basicInfoManagement/tagManagement/index.vue'),
                        meta: {
                            title: "媒体页面",
                            activeMenu:'/basic_info_management/tag_management',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/basic_info_management/tag_management/bloc_management_page',
                        name:'bloc_management_page',
                        component: () => import('@/views/basicInfoManagement/tagManagement/index.vue'),
                        meta: {
                            title: "集团页面",
                            activeMenu:'/basic_info_management/tag_management',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/basic_info_management/tag_management/company_management_page',
                        name:'company_management_page',
                        // component: () => import('@/views/basicInfoManagement/tagManagement/index.vue'),
                        meta: {
                            title: "客户页面",
                            activeMenu:'/basic_info_management/tag_management',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/basic_info_management/tag_management/plat_username_page',
                        name:'plat_username_page',
                        // component: () => import('@/views/basicInfoManagement/tagManagement/index.vue'),
                        meta: {
                            title: "代理页面",
                            activeMenu:'/basic_info_management/tag_management',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/basic_info_management/tag_management/account_management_page',
                        name:'account_management_page',
                        // component: () => import('@/views/basicInfoManagement/tagManagement/index.vue'),
                        meta: {
                            title: "账户页面",
                            activeMenu:'/basic_info_management/tag_management',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/basic_info_management/tag_management/plan_management_page',
                        name:'plan_management_page',
                        // component: () => import('@/views/basicInfoManagement/tagManagement/index.vue'),
                        meta: {
                            title: "计划页面",
                            activeMenu:'/basic_info_management/tag_management',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/basic_info_management/tag_management/app_management_page',
                        name:'app_management_page',
                        // component: () => import('@/views/basicInfoManagement/tagManagement/index.vue'),
                        meta: {
                            title: "产品页面",
                            activeMenu:'/basic_info_management/tag_management',
                            isTabItem:true,
                        },
                    },
                    {
                        path:'/basic_info_management/tag_management/project_management_page',
                        name:'project_management_page',
                        // component: () => import('@/views/basicInfoManagement/tagManagement/index.vue'),
                        meta: {
                            title: "项目页面",
                            activeMenu:'/basic_info_management/tag_management',
                            isTabItem:true,
                        },
                    },
                ],
            },
            {
                path: '/basic_info_management/project_management',
                name: 'project_management',
                component: () => import('@/views/basicInfoManagement/projectManagement/index.vue'),
                meta: {
                    title: "项目管理",
                    desc:'可在产品整合管理中查看和维护投放的所有主产品与标签管理。',
                },
            },
            {
                path: '/basic_info_management/customer_app_management',
                name: 'customer_app_management',
                component: () => import('@/views/basicInfoManagement/customerAppManagement/index.vue'),
                meta: {
                    title: "客户产品管理",
                    desc:'可在此页面维护客户和产品之间的对应关系，为投放进行底层能力建设。',
                },
            },
            {
                path: '/basic_info_management/customer_app_management_v2',
                name: 'customer_app_management_new',
                component: () => import('@/views/basicInfoManagement/customerAppManagementV2/index.vue'),
                meta: {
                    title: "客户产品管理V2",
                    desc:'可在此页面维护客户和产品之间的对应关系，为投放进行底层能力建设。',
                },
            },
            {
                path: '/basic_info_management/app_management',
                name: 'app_management',
                component: () => import('@/views/basicInfoManagement/appManagement/index.vue'),
                meta: {
                    title: "产品管理",
                    desc:'提供产品录入功能',
                },
            },
        ],
    },
    {
        path: '/system_tool',
        name: 'system_tool',
        component: Layout,
        alwaysShow:true,
        meta: {
            title: "系统工具",
            icon: 'icon-jt-settings',
        },
        children: [
            {
                path: '/system_tool/system_log',
                name: 'system_log',
                component: () => import('@/views/systemTool/log/index.vue'),
                meta: {
                    title: "系统日志",
                    isTabPage:true,
                    activeMenu:'/system_tool/system_log',
                },
            },
            {
                path: '/system_tool/spider_module',
                name: 'spider_module',
                component: () => import('@/views/systemTool/spiderModule.vue'),
                meta: {
                    title: "爬虫维护",
                    isTabPage:true,
                    activeMenu:'/system_tool/spider_module',
                },
                alwaysShow:false,
                // children:[
                //     {
                //         path:'/data_center/spider_module/spider_page',
                //         name:'spider_page',
                //         meta: {
                //             title: "爬虫打码",
                //             activeMenu:'/system_tool/spider_module',
                //         },
                //     },
                //     {
                //         path:'/data_center/spider_module/plat_agent_page',
                //         name:'plat_agent_page',
                //         meta: {
                //             title: "媒体账户维护",
                //             activeMenu:'/system_tool/spider_module',
                //         },
                //     },
                // ],
            },
            {
                path: 'retry_data_module',
                name: 'retry_data_module',
                component: () => import('@/views/systemTool/retry.vue'),
                meta: {
                    title: "重抓数据",
                },
            },
            {
                path: 'config_manage',
                name: 'config_manage',
                component: () => import('@/views/systemTool/config'),
                meta: {
                    title: "配置管理",
                },
            },
            {
                path: '/system_tool/material_compare',
                name: 'material_compare',
                component:  () => import('@/views/systemTool/materialCompare/index.vue'),
                meta: {
                    title: "素材比对",
                    isTabPage:true,
                    activeMenu:'/system_tool/material_compare',
                },
                alwaysShow:false,
                children:[
                    {
                        path:'/system_tool/material_compare/material_compare_page',
                        name:'material_compare_page',
                        component: () => import('@/views/systemTool/materialCompare/index.vue'),
                        meta: {
                            title: "比对管理",
                            isTabItem:true,
                            activeMenu:'/system_tool/material_compare',
                        },
                    },
                ]
            },
        ],
    },
    {
        path: '/authority_management',
        name: 'authority_management',
        component: Layout,
        alwaysShow:true,
        meta: {
            title: "权限管理",
            icon: 'icon-jt-auth',
        },
        children: [
            {
                path: 'organization_management',
                name: 'organization_management',
                component: () => import('@/views/authorityManagement/OrganizationManagement.vue'),
                meta: {
                    title: "组织架构管理",
                },
            },
            {
                path: 'role_management',
                name: 'role_management',
                component: () => import('@/views/authorityManagement/RoleManagement.vue'),
                meta: {
                    title: "角色管理",
                },
            },
            {
                path: 'bind_media_account',
                name: 'bind_media_account',
                component: () => import('@/views/authorityManagement/AccountManagement.vue'),
                meta: {
                    title: "媒体账户绑定",
                },
            },
        ],
    },
];

export const notFindRoutes = [
    {
        path: '/404',
        name: '404',
        component: () => import('@/views/404.vue'),
        hidden: true,
        meta: {
            title: "页面不存在",
        },
    },
    {
        path: '/no-auth',
        name: 'no-auth',
        component: () => import('@/views/NoPermission.vue'),
        hidden: true,
        meta: {
            title: "页面无权限",
        },
    },
    {
        path: '*',
        redirect: '/404',
        hidden: true,
    },
];


const createRouter = () => new VueRouter({
    mode: 'history',
    scrollBehavior: () => ({y: 0}),
    routes: constantRoutes,
    base: '/td/'
});

const router = createRouter();

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher;
}

/*
*  Hack Error: Redirected when going from "/" to "/" via a navigation guard
*  参考：https://www.jianshu.com/p/3f837b517e33
* */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
    return originalPush.call(this, location).catch(err => err)
};

export default router
